import { BillableMaterialDTO } from '../../api/generated';
import { BillableMaterial } from './types';

export function toBillableMaterial(bmDTO: BillableMaterialDTO): BillableMaterial {
  return {
    id: bmDTO.id,
    name: bmDTO.name,
    articleNumber: bmDTO.article_number,
    conditionSets: bmDTO.condition_set.map((conditionSet, i) => ({
      id: `rule-${i}`,
      conditions: conditionSet.conditions,
    })),
    jobsiteIds: bmDTO.jobsite_ids,
  };
}
